import type { Body, Scene } from "../types/scene";

type SceneObservabilitySummary = {
  bodyCount: number;
  geomCount: number;
  jointCount: number;
  siteCount: number;
  cameraCount: number;
  materialCount: number;
  textureCount: number;
  hfieldCount: number;
  contactPairCount: number;
  contactExcludeCount: number;
  equalityCount: number;
  tendonCount: number;
  actuatorCount: number;
  sensorCount: number;
};

const recordCount = (value: unknown): number => {
  if (!value || typeof value !== "object") return 0;
  return Object.keys(value).length;
};

const arrayCount = (value: unknown): number => (Array.isArray(value) ? value.length : 0);

const bodyGeomCount = (bodies: Scene["bodies"] | undefined): number => {
  if (!bodies || typeof bodies !== "object") return 0;
  return Object.values(bodies).reduce((count, body: Body) => count + arrayCount(body.geoms), 0);
};

export const getSceneObservabilitySummary = (
  scene: Partial<Scene> | null | undefined
): SceneObservabilitySummary => ({
  bodyCount: recordCount(scene?.bodies),
  geomCount: bodyGeomCount(scene?.bodies),
  jointCount: recordCount(scene?.joints),
  siteCount: recordCount(scene?.sites),
  cameraCount: recordCount(scene?.cameras),
  materialCount: recordCount(scene?.materials),
  textureCount: recordCount(scene?.textures),
  hfieldCount: recordCount(scene?.hfields),
  contactPairCount: arrayCount(scene?.contactPairs),
  contactExcludeCount: arrayCount(scene?.contactExcludes),
  equalityCount: recordCount(scene?.equality),
  tendonCount: recordCount(scene?.tendons),
  actuatorCount: recordCount(scene?.actuators),
  sensorCount: recordCount(scene?.sensors),
});
